import SchedulerConfiguration from '@/models/SchedulerConfiguration/SchedulerConfiguration';

export default class SchedulerConfigurationFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.intervalTypeId  = '';
		this.intervalTypeName = '';
		this.intervalValue = '';
		this.intervalValue2 = '';
		this.intervalValue3 = '';
		this.cronExpression = '';
		this.jobTypeId  = '';
		this.jobTypeJobName = '';
		this.recurringJobId = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			intervalTypeId : '0',
			intervalTypeName : '0',
			intervalValue : '0',
			intervalValue2 : '0',
			intervalValue3 : '0',
			cronExpression : '0',
			jobTypeId : '0',
			jobTypeJobName : '0',
			recurringJobId : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}